
export const getInitials = (name?: string): string => {
  if (!name) return '?';
  return name.split(' ').map(s => s[0]).join('');
}
